import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"20px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "text-muted" }
const _hoisted_5 = { class: "col-lg-6 d-flex flex-column justify-content-end" }
const _hoisted_6 = {
  class: "mt-5",
  style: {"height":"calc(100vh - 300px)"}
}

import $ from "jquery"
    import { computed, onMounted, onBeforeUnmount, watch, nextTick, ref, type Ref } from "vue"
    import { useRoute } from "vue-router"

    import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue'
    import PortfolioScenarioNavigation from '@Quest/PortfolioScenarios/Components/PortfolioScenarioNavigation.vue'

    import { MonthYearHelpers } from '@common/types'
    import { useSchedulingPageQueryV1 } from '@Quest/PortfolioScenarios/queries-vue-composables'
    import type { SchedulingPageReadModel } from '@Quest/PortfolioScenarios/readmodels'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SchedulingPage',
  setup(__props) {

    const kendo$ = ((window as any).kendo?.jQuery ?? $) as JQueryStatic

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params?.workspaceId ?? 0))
    const tchProjectId = computed(() => Number(route.params?.tchProjectId ?? 0))
    const scenarioId = computed(() => String(route.params?.scenarioId ?? ''))

    const {
        runSchedulingPageQueryV1,
        modelSchedulingPageQueryV1
    } = useSchedulingPageQueryV1(workspaceId, tchProjectId, scenarioId)

    const rm = modelSchedulingPageQueryV1 as Ref<SchedulingPageReadModel | null>

    const ds = computed(() =>
    {
        if (!rm.value) return []

        return rm.value.Projects
            .filter(a => a.EndDate)
            .map(a =>
            {
                const start = MonthYearHelpers.toDate(
                    MonthYearHelpers.buildFromMonthYearString(a.StartDate)
                )

                const end = MonthYearHelpers.toDate(
                    MonthYearHelpers.buildFromMonthYearString(a.EndDate)
                )

                return {
                    id: a.Id,
                    title: a.Name,
                    start,
                    end
                }
            })
    })

    const ganttRef = ref<HTMLElement | null>(null)

    function edit(e: any)
    {
        const selection = e.sender.select()
        const task = e.sender.dataItem(selection)

        const alternative = rm.value?.Projects.find(a => a.Id === task.id)
    }

    function ensureGantt()
    {
        const el = ganttRef.value
        if (!el) return

        const existing = (kendo$(el) as any).data("kendoGantt")

        if (existing)
        {
            existing.setDataSource(
                new (window as any).kendo.data.GanttDataSource({
                    data: ds.value
                })
            )
            return
        }

        (kendo$(el) as any).kendoGantt({
            editable: false,
            height: "100%",
            tooltip: { visible: false },
            views: [
                { type: "year", selected: true }
            ],
            columns: [
                { field: "title", title: "Name", sortable: true },
                { field: "start", title: "Start", format: "{0:MM/yyyy}", sortable: true, width: 120 },
                { field: "end", title: "End", format: "{0:MM/yyyy}", sortable: true, width: 120 }
            ],
            dataSource: ds.value,
            change: (e: any) => edit(e)
        })
    }


    // ======================
    // Lifecycle
    // ======================

    onMounted(() =>
    {
        document.title = "Portfolio Plan - Schedule"
        runSchedulingPageQueryV1()
    })

    watch(rm, async (current) =>
    {
        if (!current) return

        await nextTick()
        ensureGantt()
    })

    onBeforeUnmount(() =>
    {
        const gantt = (kendo$(ganttRef.value) as any)?.data("kendoGantt")
        if (gantt) gantt.destroy()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PortfolioNavigation, {
      workspaceId: workspaceId.value,
      projectId: tchProjectId.value
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("small", _hoisted_4, _toDisplayString(_unref(rm).PortfolioName) + " / " + _toDisplayString(_unref(rm).ScenarioName), 1 /* TEXT */),
              _cache[0] || (_cache[0] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Plan: Schedule", -1 /* CACHED */))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(PortfolioScenarioNavigation, {
                portfolioId: _unref(rm).PortfolioId,
                corporateScenarioUrl: _unref(rm).CorporateScenarioUrl
              }, null, 8 /* PROPS */, ["portfolioId", "corporateScenarioUrl"])
            ])
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              ref_key: "ganttRef",
              ref: ganttRef,
              style: {"height":"100%"}
            }, null, 512 /* NEED_PATCH */)
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})